import React from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';

import { isAuthenticated } from 'utilites/isAuthenticated';

const PrivateRoute = ({ component: Component, path }: RouteProps) => {
  if (!isAuthenticated()) {
    return <Redirect to="/matricula/login" />;
  }

  return <Route component={Component} path={path} />;
};

export default PrivateRoute;